export default __webpack_public_path__ + "static/media/banner102.c997f359.jpg";